export default __webpack_public_path__ + "static/badge-extended-e2ae6890b61289aba9dfde968c737f6e.webp";